<template> 
    <div class="coupon-sucess-badge">
        <img
            class=""
            src="../assets/images/celeb.svg"
            alt=""
        />
        <span class="coupon-sucess-text">{{ label }}</span>
    </div>
  </template>
  
  <script>
  export default {
    name: "BadgeNotification",
    props: {
      label: {
        type: String,
        required: true
      },
    },
  };
  </script>
<style lang="sass">
#paypalButton
  width: 100%
.coupon-sucess-badge
  background-color: #84EBB4
  border-radius: 12px
  padding-inline: 12px
  padding-block: 3px
  margin-top: 10px
  display: flex
  flex-direction: row
  gap: 5px
.coupon-sucess-text
  font-size: 16px
  font-family: "Nunito-ExtraBold"
  color: #020076
</style>
  